import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { QrCodeIcon, VisibilityOutlinedIcon, AdminPanelSettingsIcon } from 'icons/materialIcons';

const TeamMemberCardOptionsModal = ({ open, onClose, anchorEl, onDownloadQrCode, onViewCard, onEditAdminStatus, showAdminRole = false }) => {
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (!open || !anchorEl) return;

        const calculatePosition = () => {
            const rect = anchorEl.getBoundingClientRect();
            const modalWidth = 200;
            const gap = 8;
            const padding = 8;

            let top = rect.bottom + gap;
            let left = rect.right - modalWidth;

            if (left < padding) {
                left = padding;
            }

            if (left + modalWidth > window.innerWidth - padding) {
                left = window.innerWidth - modalWidth - padding;
            }

            setModalPosition({ top, left });
        };

        calculatePosition();
        window.addEventListener('resize', calculatePosition);
        return () => window.removeEventListener('resize', calculatePosition);
    }, [open, anchorEl]);

    if (!open) return null;

    const options = [
        {
            key: 'download-qr',
            label: 'Down QR Code',
            icon: <QrCodeIcon />,
            onClick: onDownloadQrCode
        },
        {
            key: 'view-card',
            label: 'View Card',
            icon: <VisibilityOutlinedIcon />,
            onClick: onViewCard
        },
        ...(showAdminRole ? [{
            key: 'edit-admin-status',
            label: 'Edit admin status',
            icon: <AdminPanelSettingsIcon />,
            onClick: onEditAdminStatus
        }] : [])
    ];

    const iconStyles = {
        color: '#828282',
        fontSize: '1.25rem',
        marginRight: '0.625rem',
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1200,
                backgroundColor: 'transparent',
            }}
            onClick={(event) => {
                event.stopPropagation();
                onClose();
            }}
        >
            <Box
                onClick={(event) => event.stopPropagation()}
                sx={{
                    position: 'absolute',
                    top: `${modalPosition.top}px`,
                    left: `${modalPosition.left}px`,
                    backgroundColor: '#fff',
                    borderRadius: '0.75rem',
                    width: '12.5rem',
                    boxShadow: '0 0.25rem 1rem rgba(0, 0, 0, 0.08), 0 0.125rem 0.5rem rgba(0, 0, 0, 0.04)',
                    padding: '0.5rem',
                    outline: 'none',
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {options.map((option) => (
                        <Box
                            key={option.key}
                            onClick={(event) => {
                                event.stopPropagation();
                                if (option.onClick) {
                                    option.onClick();
                                }
                                onClose();
                            }}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '0.625rem 0.75rem',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                borderRadius: '0.5rem',
                                '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                },
                            }}
                        >
                            {React.cloneElement(option.icon, { sx: iconStyles })}
                            <Typography
                                sx={{
                                    fontWeight: 500,
                                    fontSize: '0.8rem',
                                    color: '#333',
                                }}
                            >
                                {option.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default TeamMemberCardOptionsModal;
